import { memo, useMemo } from 'react';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { AuthNavigatorParamsList } from '../../../navigators/AuthNavigator/AuthNavigator.types';
import { Trans } from '@bonanza-social/i18n';
import { selectExistingUserName } from '../../../state';

function IntroMainContentExistingPlayer() {
  const navigation =
    useNavigation<StackNavigationProp<AuthNavigatorParamsList>>();
  const existingUserName = useSelector(selectExistingUserName);

  const registerComponent = useMemo(
    () => ({
      textLink: (
        <Text
          variant="link-small"
          onPress={() => navigation.navigate('RegistrationScreen')}
        />
      ),
    }),
    [],
  );
  return (
    <Box gap="space-400" paddingBottom="space-500">
      <Text
        variant="h4"
        locNS="auth"
        locKey="introScreenUserName"
        paddingBottom="-space-100"
        numberOfLines={1}
        gradient="darkSurfaceAccent"
        alignSelf="center"
      >
        <Trans
          i18nKey="introScreenUserName"
          ns="auth"
          values={{ name: existingUserName ?? '' }}
          tOptions={{ interpolation: { escapeValue: false } }}
        />
      </Text>
      <Text
        variant="h4"
        locNS="auth"
        locKey="introScreenWelcomeBack"
        marginTop="-space-200"
        gradient="darkSurfaceAccent"
        alignSelf="center"
      ></Text>
      <Box gap="space-300" paddingBottom="space-300">
        <Button
          locKey="login"
          locNS="auth"
          size="large"
          onPress={() => navigation.navigate('LoginScreen')}
        />
        <Text
          marginTop="space-200"
          variant="body-s"
          color="darkSurfacePrimary"
          alignSelf="center"
        >
          <Trans
            i18nKey="introScreenRegisterFooterText"
            ns="auth"
            components={registerComponent}
          />
        </Text>
      </Box>
    </Box>
  );
}
export default memo(IntroMainContentExistingPlayer);
